import React, { memo } from 'react'
import { Box, Card } from '@mui/material'
import { Trans } from 'react-i18next'

import CardHeading from '../shared/text/CardHeading'
import { SCRATCH_CARD_VALUE } from '../../constants/game'
import { formatTicks } from '../../util/string.helpers'
import { getMaxRewardValue } from '../../util/game.helpers'

const HowToPlay = ({ t, symbol }) => {
  const helpText = [
    'game.help.open',
    'game.help.scratch',
    'game.help.get-lucky',
    'game.help.play-again'
  ]
  return (
    <Card sx={{ p: 3 }}>
      <CardHeading
        title={t('game.how-to-play')}
        desc={
          <Trans
            i18nKey='game.how-to-play-desc'
            values={{
              value: SCRATCH_CARD_VALUE,
              symbol
            }}
          />
        }
      />
      <Box component='ol' typography='body2' pl={2.5} mb={0}>
        {helpText.map((label) => (
          <li key={label}>
            {t(label, {
              value: formatTicks(getMaxRewardValue()?.value),
              symbol
            })}
          </li>
        ))}
      </Box>
    </Card>
  )
}

export default memo(HowToPlay)
